import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { CreateProjectTemplateInput } from "tekkr-common/dist/model/project/project-template";

interface Options {
    onSuccess?: () => void;
}

export function useSaveProjectAsTemplateMutation(options?: Options) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (input: CreateProjectTemplateInput) => {
            const res = await apiClient.saveProjectAsTemplate({
                body: input,
            });
            if (res.status !== 201) {
                throw new Error("Failed to save template");
            }
            return res.body;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ["templates"] });
            options?.onSuccess?.();
        },
    });
}
